import { CalendarInfo, Schedule, CalendarType } from "@/api/calendar";
import dayjs, { Dayjs } from "dayjs";
import React, { useState, useRef, useEffect } from "react";
import {
  getRealColor,
  getScheduleTimeForTooltip,
  getTaskTimeForTooltip
} from "@/components/Calendars/utils";
import { useTranslation } from "react-i18next";
import "./index.less";
import solarLunar from "solarlunar";
import SchedulePopover from "@/components/Calendars/Schedule/SchdeulePopover";
import { getTypeImage } from "@/components/Calendars/utils/getTypeImage";
import ScrollView from "@/baseComponents/ScrollView";
import { Tooltip } from "antd";

import { Interface } from "readline";
import { CustomCalendarKeys } from "@/models/calendar";
import TaskPopover from "@/components/Calendars/Task/TaskPopover";
import { TASK_STATUS } from "@/types/newWork";
export function splitWeekCols(scheduleMap: Array<Schedule[]>, weekList: Dayjs[]) {
  scheduleMap.forEach((c) => {
    c.sort((a, b) => {
      if (a.scheduleBeginTime.unix() === b.scheduleBeginTime.unix()) {
        return (
          b.scheduleEndTime.unix() -
          b.scheduleBeginTime.unix() -
          (a.scheduleEndTime.unix() - a.scheduleBeginTime.unix())
        );
      }
      return a.scheduleBeginTime.unix() - b.scheduleBeginTime.unix();
    });
  });

  const map: Array<Schedule[]> = [];
  weekList.forEach((w) => {
    map.push([]);
  });
  scheduleMap.forEach((c, index) => {
    c.forEach((element) => {
      const col = map[index];
      if (index === 0) {
        col.push(element);
        return;
      }

      const last = map[index - 1];
      const inx = last.findIndex((l) =>
        ((l?.isAcross && element.isAcross) || (l?.isAlldate && element.isAlldate)) &&
        l?.repeat &&
        element.repeat
          ? l?.repeatScheduleId === element.repeatScheduleId
          : l?.scheduleId === element.scheduleId
      );
      if (inx === -1) {
        const length = col.length;
        for (let i = 0; i <= length; i++) {
          if (col[i]) {
            continue;
          }
          col[i] = element;
          break;
        }
      } else {
        col[inx] = element;
      }
    });
  });
  return map;
}
export enum AllDayCompType {
  WEEK = "week",
  DAY = "day"
}

/**
 *
 * @param param
 */
// eslint-disable-next-line complexity
export function generateCol({
  list,
  col,
  customsComps,
  time,
  expand,
  t,
  rowsNum,
  setExpand,
  hoverScheduleId,
  setHoverScheduleId,
  myCalendar,
  type
}: {
  customsComps?: any;
  list: Schedule[];
  col: number;
  time: Dayjs;
  expand: boolean;
  t: any;
  rowsNum: number;
  setExpand: (flag: boolean) => void;
  hoverScheduleId?: any;
  setHoverScheduleId?: Function;
  myCalendar: any;
  type?: AllDayCompType;
}) {
  let length = list.length;
  if (length === 0 && !customsComps) {
    return [];
  }
  const items = [];
  if (length > rowsNum && !expand) {
    length = rowsNum;
  }

  for (let i = 0; i < length; i++) {
    const schedule = list[i];
    const isPast = dayjs().isAfter(schedule?.scheduleEndTime);
    if (!schedule) {
      items.push(<div key={col + "-" + i} className="allday-col-item allday-col-item-empty" />);
      continue;
    }
    const isHover =
      hoverScheduleId === (schedule.repeat ? schedule.repeatScheduleId : schedule.scheduleId);
    const color = getRealColor(schedule.color || schedule.calendarInfo?.color);
    const backgroundColor = isHover
      ? `${schedule.comeFrom === 5 ? color + "66" : "rgba(22,134,255,0.25)"}`
      : `${schedule.comeFrom === 5 ? color + "26" : "#FFFFFF"}`;

    const isinit = schedule.scheduleBeginTime.isSame(time, "date");
    const isOneDay = schedule.scheduleEndTime
      .subtract(1, "second")
      .isSame(schedule.scheduleBeginTime, "date");
    const isEndDay = schedule.scheduleEndTime.subtract(1, "second").isSame(time, "date");
    const isWeekView = type === AllDayCompType.WEEK;
    const isDayView = type === AllDayCompType.DAY;

    if (schedule.dataType === "task") {
      items.push(
        <TaskPopover key={i} item={schedule}>
          <Tooltip
            overlayClassName="calendar-view-title-tooltip"
            title={getTaskTimeForTooltip(schedule, true, time, t)}
          >
            <div className="allday-col-item-wrapper">
              <div
                className={`allday-col-item allday-col-item ${
                  isinit || col === 0 ? "allday-col-item-init" : ""
                } ${isOneDay ? "allday-col-item-oneday" : ""} 
                           ${isPast ? "allday-col-item-timepast" : ""}
                           ${isEndDay ? "allday-col-item-endday" : ""}
                           ${isDayView ? "allday-col-item-dayview" : ""} ${
                  isWeekView ? "allday-col-item-weekview" : ""
                }`}
                onMouseEnter={() => {
                  setHoverScheduleId?.(
                    schedule.repeat ? schedule.repeatScheduleId : schedule.scheduleId
                  );
                }}
                onMouseLeave={() => {
                  setHoverScheduleId?.("");
                }}
                style={{
                  backgroundColor: backgroundColor,
                  cursor: "pointer"
                }}
              >
                {(col === 0 || schedule.scheduleBeginTime.isSame(time, "date")) && (
                  <div className="col-item-content">
                    {schedule.comeFrom !== 5 && (
                      <div
                        className={`pre-circle-task pre-circle-task-${
                          schedule.dueTag ? 4 : schedule.taskStatus
                        }`}
                      >
                        <div
                          className="pre-circle"
                          style={{
                            backgroundImage: `url(${getTypeImage(schedule.color)})`
                          }}
                        />
                      </div>
                    )}
                    <span
                      className={`${
                        !schedule.dueTag &&
                        (schedule.taskStatus === TASK_STATUS.FINISHED ||
                          schedule.taskStatus === TASK_STATUS.ABORT)
                          ? "title-decoration"
                          : ""
                      }`}
                    >
                      {schedule.title}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </Tooltip>
        </TaskPopover>
      );
    } else {
      items.push(
        <SchedulePopover key={i} item={schedule} selectedScheduleTime={time}>
          <Tooltip
            overlayClassName="calendar-view-title-tooltip"
            title={`${schedule.isBusy ? schedule.realName + " " + t("busy") : schedule.title}${
              " " + getScheduleTimeForTooltip(schedule, false, time, t)
            }`}
          >
            <div className="allday-col-item-wrapper">
              <div
                className={`allday-col-item allday-col-item ${
                  isinit || col === 0 ? "allday-col-item-init" : ""
                } ${isOneDay ? "allday-col-item-oneday" : ""} 
                           ${isPast ? "allday-col-item-timepast" : ""}
                           ${isEndDay ? "allday-col-item-endday" : ""}
                           ${isDayView ? "allday-col-item-dayview" : ""} ${
                  isWeekView ? "allday-col-item-weekview" : ""
                }`}
                onMouseEnter={() => {
                  setHoverScheduleId?.(
                    schedule.repeat ? schedule.repeatScheduleId : schedule.scheduleId
                  );
                }}
                onMouseLeave={() => {
                  setHoverScheduleId?.("");
                }}
                style={{
                  // color,
                  backgroundColor: backgroundColor,
                  cursor: "pointer"
                }}
              >
                {(col === 0 || schedule.scheduleBeginTime.isSame(time, "date")) && (
                  <div className="col-item-content">
                    {schedule.comeFrom !== 5 && (
                      <div
                        className="pre-circle"
                        style={{
                          backgroundImage: `url(${getTypeImage(schedule.color)})`
                        }}
                      />
                    )}
                    {schedule.calendarType !== CalendarType.PublicType &&
                    schedule.comeFrom !== 1 &&
                    schedule.comeFrom !== 4 &&
                    schedule.realName
                      ? schedule.realName + " "
                      : ""}
                    {schedule.isBusy ? t("busy") : schedule.title}
                  </div>
                )}
              </div>
            </div>
          </Tooltip>
        </SchedulePopover>
      );
    }
  }
  if (customsComps) {
    items.push(customsComps);
  }
  return items;
}

export function DayViewAlldayComp({
  list,
  current,
  myCalendar
}: {
  list: Schedule[];
  current: Dayjs;
  myCalendar: any;
}) {
  const [expand, setExpand] = useState(false);
  const [hoverScheduleId, setHoverScheduleId] = useState("");
  const { t } = useTranslation("calendar");
  const rowsNum = list.length;
  const year = current.year();
  let month = current.month() || 0;
  const date = current.date();
  const day = current.day();
  const lunar = solarLunar.solar2lunar(year, month + 1, date);
  const scrollRef: any = useRef(null);
  return (
    <div className="dayview-allday allday-comp">
      <div className="allday-comp-container">
        <div className="allday-comp-header">{t("allday")}</div>
        <div className="allday-comp-content-wrapper">
          <ScrollView ref={scrollRef} nohorizontal="true" className="scroll-view" autoHide>
            <div className="allday-comp-content">
              {generateCol({
                list,
                t,
                expand,
                setExpand,
                col: 0,
                time: current,
                rowsNum,
                hoverScheduleId,
                setHoverScheduleId,
                myCalendar,
                type: AllDayCompType.DAY
              })}
            </div>
          </ScrollView>
        </div>
      </div>
    </div>
  );
}

export function getComputedAllday({
  scheduleMap,
  weekList,
  customList,
  expand,
  t,
  setExpand,
  rowsNum,
  hoverScheduleId,
  setHoverScheduleId,
  myCalendar
}: {
  scheduleMap: Array<Schedule[]>;
  weekList: Dayjs[];
  customList?: any;
  expand: boolean;
  t: any;
  rowsNum: number;
  setExpand: (flag: boolean) => void;
  hoverScheduleId?: any;
  setHoverScheduleId?: Function;
  myCalendar: any;
}) {
  const map = splitWeekCols(scheduleMap, weekList);
  return weekList.map((w, index) => {
    const customs = customList[CustomCalendarKeys.RestrictNoList]?.find(
      (item: any) => item.date === w.format("YYYY-MM-DD")
    );
    const customsComps = customs?.restrictNo ? (
      <div key={`restrict-no-${index}`} className="calendar-restrict-no-wrap">
        <span className="calendar-restrict-no" />
        {customs?.restrictNo}
      </div>
    ) : null;
    return (
      <div
        key={index}
        className={`allday-col ${dayjs().day() === dayjs(w).day() ? "weekview-week-current" : ""}`}
      >
        {generateCol({
          customsComps,
          list: map[index],
          col: index,
          time: w,
          expand,
          t,
          setExpand,
          rowsNum,
          hoverScheduleId,
          setHoverScheduleId,
          myCalendar,
          type: AllDayCompType.WEEK
        })}
      </div>
    );
  });
}
export function WeekViewAlldayComp({
  scheduleMap,
  weekList,
  customList,
  myCalendar
}: {
  scheduleMap: Array<Schedule[]>;
  weekList: Dayjs[];
  customList?: any;
  myCalendar: any;
}) {
  console.info("weekList", customList);
  const [expand, setExpand] = useState(true);
  const [hoverScheduleId, setHoverScheduleId] = useState("");
  const { t } = useTranslation("calendar");
  const rowsNum = 3;
  let maxLength = 0;
  const count = scheduleMap.reduce((p, v) => {
    const sum = p + v.length;
    maxLength = Math.max(maxLength, v.length);
    return sum;
  }, 0);
  const scrollRef: any = useRef(null);

  return (
    <div className="weekview-allday allday-comp">
      <div className="allday-comp-container">
        <div className="allday-comp-header">{t("allday")}</div>
        <div className="allday-comp-content-wrapper">
          <ScrollView ref={scrollRef} nohorizontal="true" className="scroll-view" autoHide>
            <div className="allday-comp-content">
              {getComputedAllday({
                customList,
                scheduleMap,
                weekList,
                expand,
                setExpand,
                t,
                rowsNum,
                setHoverScheduleId,
                hoverScheduleId,
                myCalendar
              })}
            </div>
          </ScrollView>
        </div>
      </div>
    </div>
  );
}
